export default __webpack_public_path__ + "static/media/help_icon.d694c68e.svg";